import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";
import { useCanManageAIAgents } from "./useCanManageAIAgents";

// Editing an agent requires the manage:agents permission AND an editor/manager
// role on the agent. A USER-level grant is view-only even for an admin, and
// SYSTEM agents are read-only for everyone.
export const useCanEditAgent = (agent: Agent): boolean => {
  const canManage = useCanManageAIAgents();
  return (
    canManage && agent.scope !== AgentScope.SYSTEM && agent.access_level !== AgentAccessLevel.USER
  );
};
